import { render, staticRenderFns } from "./profession-detail.vue?vue&type=template&id=7ffe856f&scoped=true&"
import script from "./profession-detail.vue?vue&type=script&lang=js&"
export * from "./profession-detail.vue?vue&type=script&lang=js&"
import style0 from "./profession-detail.vue?vue&type=style&index=0&id=7ffe856f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffe856f",
  null
  
)

export default component.exports